function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { Swiper, defaultSwiperSettings } from '../../../src/js/swiper-utils';
document.addEventListener("DOMContentLoaded", function () {
  if (document.querySelectorAll('.news-block-block')) {
    var sliders = document.querySelectorAll('.news-block-block');
    sliders.forEach(function (slider) {
      var developmentsSlider = new Swiper(slider.querySelector('.swiper'), _objectSpread(_objectSpread({}, defaultSwiperSettings('auto', 330, false, false)), {}, {
        spaceBetween: 30,
        centeredSlides: false,
        loop: false,
        slidesPerView: 1.2,
        pagination: {
          el: slider.querySelector('.swiper-pagination'),
          clickable: true,
          freeMode: true,
          renderBullet: function renderBullet(index, className) {
            return '<button aria-label="Go to slide ' + (index + 1) + '" class="' + className + '">' + "</button>";
          }
        },
        navigation: {
          nextEl: slider.querySelector('.swiper-button-next'),
          prevEl: slider.querySelector('.swiper-button-prev')
        },
        breakpoints: {
          768: {
            slidesPerView: 1.5
          },
          880: {
            slidesPerView: 2.2
          },
          1280: {
            slidesPerView: 1.5
          },
          1536: {
            slidesPerView: 2.5
          }
        }
      }));
    });
  }
});